import { render, staticRenderFns } from "./ap_reports_detail.vue?vue&type=template&id=0fcaada1&"
import script from "./ap_reports_detail.vue?vue&type=script&lang=js&"
export * from "./ap_reports_detail.vue?vue&type=script&lang=js&"
import style0 from "./ap_reports_detail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports